import { LoadScriptNext } from "@react-google-maps/api";
import { GOOGLE_API_KEY, GOOGLE_MAP_LIBRARIES } from "../constant/common";
import Spinner from "../components/common/Spinner";

const GoogleMapsLoader = ({ children, adminLayout = false, masterAdminLayout = false }) => {
  return (
    <LoadScriptNext 
      googleMapsApiKey={GOOGLE_API_KEY} 
      libraries={GOOGLE_MAP_LIBRARIES}      
      loadingElement={<Spinner adminLayout={adminLayout} masterAdminLayout={masterAdminLayout}/>}
      >
      {children}
    </LoadScriptNext>
  );
};

export default GoogleMapsLoader;
